import { render } from "./Course.vue?vue&type=template&id=3be939e6&scoped=true&ts=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"

import "./Course.vue?vue&type=style&index=0&id=3be939e6&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be939e6"]])

export default __exports__